var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.00001 9.47499L1.52501 5.99999L0.341675 7.17499L5.00001 11.8333L15 1.83333L13.825 0.658325L5.00001 9.47499Z","fill":"#01C195"}));
}

Check.defaultProps = {"width":"15","height":"12","viewBox":"0 0 15 12","fill":"none"};

module.exports = Check;

Check.default = Check;
